export default __webpack_public_path__ + "static/media/Astronauta4.e89f1aaa.png";